import React from 'react'
import { useQuery } from '@apollo/client'
import { Header, List, Segment } from 'semantic-ui-react'
import { JOB_ADMIN_NOTES } from '../../../../graphql/job'

const AdminNotes = ({ job }) => {
    const { data, loading } = useQuery(JOB_ADMIN_NOTES, {
        variables: { id: job.id },
    })

    const adminNotes = loading ? '(Loading...)' : data?.job.adminNotes || '(None)'

    return (
        <List>
            <Header as="h6">Admin Notes</Header>
              <List.Item>
                <Segment>
                  <span style={{ color: 'black' }}>{adminNotes}</span>
                </Segment>
              </List.Item>
        </List>
    )
}

export default AdminNotes
